import { IRecordEducationEditItem, RecordEducationEditItem } from "./recordEducationEditItem";

export interface IRecordEducationEdit {
    education: IRecordEducationEditItem;
}

export class RecordEducationEdit implements IRecordEducationEdit {
    education: RecordEducationEditItem;

    constructor();
    constructor(obj: IRecordEducationEdit);
    constructor(obj?: any) {
        this.education = new RecordEducationEditItem(obj ? obj.education : null);
    }
}